import { useContext } from "react";
import { GlobalContext } from './GlobalContext'

export const useGlobalContext = () => {
    const context = useContext(GlobalContext);
    if (!context) {
        throw new Error("Must be used within a ModeProvider");
    }
    return context;
};